export default class Printer {
    constructor() {
        this.text = '';
    }

    addNewLine() {
        return this.addText('\n')
    }

    addBlankSpace() {
        return this.addText(' ')
    }

    addSeparator() {
        return this.addText('|')
    }

    addFestyTitle() {
        return this.addText('            FESTY APP         ')
            .addNewLine()
    }

    addLongLine() {
        return this.addText('\n_______________________________\n')
    }

    addText(text) {
        this.text += text

        return this
    }

    addTextToRight(text) {
        return this.addText(addSpaceBeforeText(text))
    }

    addProductTableHeader() {
        return this.addLongLine()
            .addText('   PRODUCTO  ')
            .addBlankSpace()
            .addSeparator()
            .addBlankSpace()
            .addText('#')
            .addBlankSpace()
            .addSeparator()
            .addBlankSpace()
            .addText('  TOTAL  ')
            .addNewLine()
    }

    addSubtotalToTable(text) {
        return this.addTextToRight(`Subtotal: ${text}`)
    }

    addTotalToTable(text) {
        return this.addTextToRight(`Total: ${text}`)
    }

    addProductToTable(name, quantity, total){
        if (stringGreaterThan(name, 14)){
            let nameArray = splitStringEachFourteen(name)

            nameArray.forEach((item, index) => {
                this.addText(productNameText(item))

                if (index === 0){
                    this.addSeparator()
                        .addText(productQuantityText(quantity))
                        .addSeparator()
                        .addText(productTotalText(total))
                        .addNewLine()
                }

                if ((index + 1) === nameArray.length){
                    this.addLongLine()
                }
            })
        } else {
            this.addText(productNameText(name))
                .addSeparator()
                .addText(productQuantityText(quantity))
                .addSeparator()
                .addText(productTotalText(total))
                .addNewLine()
                .addLongLine()
        }

        return this
    }
}

const productNameText = name => {
    return addSpaceOrRemoveTextAfterChars(name, 14)
}

const productQuantityText = quantity => {
    return addSpaceOrRemoveTextAfterChars(quantity, 3)
}

const productTotalText = total => {
    return addSpaceOrRemoveTextAfterChars(total, 9)
}

const addSpaceOrRemoveTextAfterChars = (string, maxChars) => {
    if (stringGreaterThan(string, maxChars)){
        return string.substring(maxChars)
    } else {
        let stringLength = maxChars - string.length

        for (let i = 0; i < stringLength; i++){
            string += ' '
        }

        return string
    }
}

const addSpaceBeforeText = string => {
    let text = ''

    for (let i = 0; i <= (30 - string.length); i++){ //30 is the max chars to print
        text += ' '
    }

    return text + string
}

const splitStringEachFourteen = string => {
    return string.match(/.{1,14}/g)
}

const stringGreaterThan = (string, maxLength) => {
    //eslint-disable-next-line
    return string.length > maxLength
}
